import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { IOptions, IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'

export function* setAllPNNVOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getAllPNNVOptions])
    const { entity } = response
    const formattedAllPNNVOptions: { [key: string]: IOptions[] } = {}

    entity.forEach((item: any) => {
      const key = Object.keys(item)[0]
      formattedAllPNNVOptions[key] = item[key]
    })

    yield put(actions.setAllPNNVOptions(formattedAllPNNVOptions))
  } catch (e) {
    yield put(throwPcrException(`setAllPNNVOptions() error: ${e}`))
  }
}
export function* setAllPNNVOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setAllPNNVOptions)
}
